import React from "react";
import { Outlet } from "react-router-dom";

function Reports() {
  return (
    <div>
      <Outlet />
    </div>
  );
}

export default Reports;
